const styles = {
  container: 'fixed top-0 left-0 right-0 w-full py-4 lg:py-5 z-50 bg-white',
  content: 'flex flex-row items-center justify-between bg-white gap-x-8',

  head: 'col-span-3 flex flex-row items-center',
  body: 'col-span-5 grow flex flex-row items-center justify-center',
  foot: 'col-span-3 flex flex-row items-center justify-end gap-x-4 lg:gap-x-6',

  list: 'flex-row gap-x-4 lg:gap-x-6 items-center',
  item: ' text-sm',
  separator: 'text-gray-200',
  highlight: 'text-[#29AAC7] font-semibold',

  link: 'cursor-pointer !text-sm hover:bg-gray-100 rounded-sm px-4 py-2 hover:text-gray-800 duration-300 hover:!bg-none pr-4 !font-medium',

  button:
    'px-6 py-3 rounded-xs text-white text-sm font-medium bg-[#E84F31] hover:bg-[#E84F31]/80 cursor-pointer',
};

export default styles;
